/**
 * The order of every «چه اتفاقی افتاده» timeline in the app: OLDEST AT THE
 * TOP, NEWEST AT THE BOTTOM. One rule for all of them — درخواست برداشت,
 * درخواست وام, and whatever timeline comes next. Do not reverse it on one
 * page; if the order ever has to change, change it here, for all of them.
 *
 * Why this way round, decided 2026-09-11 after the two pages were reported
 * reading in opposite directions:
 *
 * - It is a story, and a story is read top to bottom. «درخواست ثبت شد» is the
 *   first line, and every later line only makes sense after the ones above it
 *   («پرداخت ثبت شد — ۱٬۰۰۰٬۰۰۰» means nothing before the request it pays).
 * - The loan request's timeline is also a conversation, with the composer
 *   directly under it. Newest-at-the-bottom puts the latest message right
 *   above the box you answer it in, as in every messenger.
 * - «Where does it stand now?» is already answered at the top of both pages,
 *   by the state line in the summary card, so the newest row does not have to
 *   be first to be found.
 *
 * Both endpoints already send their events oldest-first. Sorting again here is
 * what makes that a guarantee instead of a coincidence: a stable sort on the
 * finest timestamp a row carries (`created_at` is minute-resolution, `created`
 * only the day), so rows that tie keep the order the server — which has the
 * full datetime — put them in.
 */
export const inTimelineOrder = <
    T extends { created?: string | null; created_at?: string | null },
>(
    events?: Array<T> | null
): Array<T> => {
    const at = (event: T) => event.created_at || event.created || ''
    // Zero-padded «1405-05-31 14:05» strings compare correctly as text.
    return [...(events ?? [])].sort((a, b) =>
        at(a) < at(b) ? -1 : at(a) > at(b) ? 1 : 0
    )
}
